import React, { useContext, useEffect } from 'react';

import { UserContext } from '../../contexts/UserContext';
import Loader from '../../components/Loader/Loader';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const userContext = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        userContext.setToken(null);
        navigate('/login', { replace: true });
    }, []);

    return <Loader />;
};

export default Logout;
